import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const LegalName = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.legalName`}
      control={control}
      rules={{
        validate: Validators.required.field
      }}
      render={({ field }) => (
        <FF2
          required
          label="57. Legal name of financial institution"
          field={field}
          input={(props) => <TextInput {...props} data-qa="57. Legal name of financial institution" />}
        />
      )}
    />
  )
}
